import BaseModel from "./BaseModel";

export default class AccountModel extends BaseModel {
  email?: string;
  uid?: string;
  timezone?: string;
  constructor(arg: any) {
    super(arg);
    this.email = arg.email;
    this.uid = arg.uid;
    this.timezone = arg.timezone;
  }
}
